import { render } from "./GraphControls.vue?vue&type=template&id=58e10446&ts=true"
import script from "./GraphControls.vue?vue&type=script&lang=ts"
export * from "./GraphControls.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__